<template lang="pug">
  div
    div(class="mb-3 headline") Breakdown of resolved maintenance jobs
    div(v-if="loading")
      div(style="display: flex; justify-content: center;")
        v-progress-circular(size="50" indeterminate)
    div(v-else)
      pie-chart(:data="categories"
                :library="style"
                :dataset="dataset")

</template>

<script>
export default {
  name: "resolved-breakdown",
  data () {
    return {
      categories: {},
      dataset: {
        backgroundColor: [
          "#E0F2F1",
          "#B2DFDB",
          "#80CBC4",
          "#4DB6AC",
          "#26A69A",
          "#009688",
          "#00897B",
          "#00796B",
          "#00695C",
          "#004D40"
        ],
        borderColor: "#303030",
        borderWidth: []
      },
      error: false,
      loading: false,
      style: {
        legend: {
          labels: { fontColor: "white" },
          position: "right"
        },
        cutoutPercentage: 40
      }
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get("/api/reports/performance").
      then((perfs) => {
        for (const perf of perfs.data) {
          if (perf["Issues count"]) {
            this.$set(this.categories, perf.Category, perf["Issues count"]);
            this.dataset.borderWidth.push(3);
          }
        }
      }).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/ResolvedBreakdown.vue